import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Router from './routes';
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
import useAuth from './hooks/useAuth';
import ScrollToTop from './components/ScrollToTop';
import NotistackProvider from './components/NotistackProvider';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import ThemeLocalization from './components/ThemeLocalization';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import LoadingScreen, { ProgressBarStyle } from './components/LoadingScreen';
import axiosInstance from './utils/axios';

export default function App() {
  const { isInitialized, user } = useAuth();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('accessToken');
      
      if (token && user) {
        try {
          await axiosInstance.get('/api/companies/user');
        } catch (error) {
          if (error.response?.status === 401) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('role');
            delete axiosInstance.defaults.headers.common.Authorization;
            navigate('/login');
          }
        }
      }
    };
    
    if (isInitialized) {
      verifyToken();
      setIsVerifying(false);
    }
  }, [isInitialized, user, navigate]);

  // Vérification périodique toutes les 30 secondes
  useEffect(() => {
    const intervalId = setInterval(async () => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        try {
          await axiosInstance.get('/api/companies/user');
        } catch (error) {
          if (error.response?.status === 401) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('role');
            delete axiosInstance.defaults.headers.common.Authorization;
            navigate('/login');
          }
        }
      }
    }, 30000);
    
    return () => clearInterval(intervalId);
  }, [navigate]);

  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <ThemeLocalization>
          <NotistackProvider>
            <GlobalStyles />
            <ProgressBarStyle />
            <BaseOptionChartStyle />
            <ScrollToTop />
            {isInitialized && !isVerifying ? <Router /> : <LoadingScreen />}
          </NotistackProvider>
        </ThemeLocalization>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}